// extracted by mini-css-extract-plugin
module.exports = {"plan-enter":"prevention_plan-enter__1ilcD","plan-enter-active":"prevention_plan-enter-active__3KcfS"};